var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "layoutTop" }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-10 offset-md-1" },
            [
              _vm.userIsGuest()
                ? _c(
                    "b-alert",
                    {
                      attrs: {
                        variant: "warning",
                        show: "",
                        dismissible: "",
                        fade: "",
                      },
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("loginPage.guest_alert_message_1"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("loginPage.guest_alert_message_2"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-10 offset-md-1" },
            [
              !_vm.userIsGuest() ? _c("back-button") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel21 panel-default" },
                [
                  _c("div", { staticClass: "panel-heading" }, [
                    _c(
                      "h4",
                      { staticClass: "content-block labelAccordionForm" },
                      [
                        _vm.details.direction === "0"
                          ? _c("div", [
                              _c("img", {
                                staticClass: "formIcon",
                                attrs: {
                                  src: require("../../../assets/static/images/icons/inbox_into.png"),
                                },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("modularLoan.ml_rqst_rcvd", {
                                      itemname: _vm.$t(
                                        this.$engine.services.getSingularNameFromServiceId(
                                          this.$engine.user.currentService.id
                                        )
                                      ),
                                    })
                                  ) +
                                  "\n                  "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.details.direction === "1"
                          ? _c("div", [
                              _c("img", {
                                staticClass: "formIcon",
                                attrs: {
                                  src: require("../../../assets/static/images/icons/inbox_out.png"),
                                },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("modularLoan.ml_rqst_sent", {
                                      itemname: _vm.$t(
                                        this.$engine.services.getSingularNameFromServiceId(
                                          this.$engine.user.currentService.id
                                        )
                                      ),
                                    })
                                  ) +
                                  "\n                  "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    { attrs: { open: "", title: _vm.ServiceDetails } },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.rsn"),
                              inputValue: _vm.details.reason,
                            },
                          }),
                          _vm._v(" "),
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.status.status_label"),
                              inputValue: _vm.getStatusLabel(
                                _vm.details.status,
                                _vm.details.direction
                              ),
                              statusIcon: _vm.getIcon(_vm.details.status, "0"),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.details.direction === "0"
                            ? [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("common.crdtr_name"),
                                    inputValue: _vm.details.creditorName,
                                  },
                                }),
                                _vm._v(" "),
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("common.crdtr_mail"),
                                    inputValue: _vm.details.creditorIdentifier,
                                  },
                                }),
                              ]
                            : _vm.details.direction === "1"
                            ? [
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("common.debtor_name"),
                                    inputValue: _vm.details.debtorName,
                                  },
                                }),
                                _vm._v(" "),
                                _c("form-read-group-label-input", {
                                  attrs: {
                                    inputLabel: _vm.$t("common.debtor_email"),
                                    inputValue: _vm.details.debtorIdentifier,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm.details.direction === "0" &&
                          _vm.details.status === "0"
                            ? _c("form-write-group-label-input", {
                                attrs: {
                                  inputLabel:
                                    _vm.details.direction === "0"
                                      ? _vm.$t("common.my_ibn")
                                      : _vm.$t("common.debtor_ibn"),
                                  inputType: "text",
                                  isMandatory:
                                    _vm.$engine.user.validateAccess(
                                      "mandatoryIban"
                                    ),
                                },
                                model: {
                                  value: _vm.details.debtorBankAccount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.details,
                                      "debtorBankAccount",
                                      $$v
                                    )
                                  },
                                  expression: "details.debtorBankAccount",
                                },
                              })
                            : _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel:
                                    _vm.details.direction === "0"
                                      ? _vm.$t("common.my_ibn")
                                      : _vm.$t("common.debtor_ibn"),
                                  inputValue:
                                    "XXXXXXXXXXXXXXXXXXXXX" +
                                    _vm.details.debtorBankAccount.substr(
                                      _vm.details.debtorBankAccount.length - 4
                                    ),
                                },
                              }),
                          _vm._v(" "),
                          _vm.details.creditorBankAccount.length
                            ? _c("form-read-group-label-input", {
                                attrs: {
                                  inputLabel:
                                    _vm.details.direction === "1"
                                      ? _vm.$t("common.my_ibn")
                                      : _vm.$t("common.crdt_ibn"),
                                  inputValue:
                                    "XXXXXXXXXXXXXXXXXXXXX" +
                                    _vm.details.creditorBankAccount.substr(
                                      _vm.details.creditorBankAccount.length - 4
                                    ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t(
                                "common.total_amount_no_currency"
                              ),
                              inputValue:
                                _vm.details.amount +
                                " " +
                                _vm.getCurrencyIcon(_vm.details.currency),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "form-read-group-label-input",
                            {
                              attrs: {
                                inputLabel: _vm.$t("common.rqst_date"),
                                inputValue: _vm._f("formatDate")(
                                  _vm.details.creationDate
                                ),
                              },
                            },
                            [
                              this.$engine.user.currentService.id !== "2" &&
                              _vm.details.status === "4" &&
                              _vm.details.direction === "1"
                                ? _c(
                                    "f7-button",
                                    {
                                      staticClass:
                                        "blueBackground col-12 col-sm-6 pain001ViewerButton",
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewXML(
                                            "pain001",
                                            _vm.details.endToEndId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      View Transfer Order File\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.$engine.user.currentService.id !== "2" &&
                              _vm.details.status === "5" &&
                              _vm.details.direction === "1"
                                ? _c(
                                    "f7-button",
                                    {
                                      staticClass:
                                        "blueBackground col-12 col-sm-6 pain001ViewerButton",
                                      on: {
                                        click: function ($event) {
                                          return _vm.viewXML(
                                            "pacs008",
                                            _vm.details.endToEndId
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      View Instant Payment File\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row justify-content-start" },
                        [
                          _c("form-read-group-label-input", {
                            attrs: {
                              formGroupWidth: "3 col-6",
                              inputLabel: _vm.$t("common.deposit_amnt_label"),
                              inputValue:
                                _vm.details.depositAmount +
                                " " +
                                _vm.getCurrencyIcon(_vm.details.currency),
                            },
                          }),
                          _vm._v(" "),
                          _c("form-read-group-label-input", {
                            attrs: {
                              formGroupWidth: "3 col-6",
                              inputLabel: _vm.$t("modularLoan.deposit_date"),
                              inputValue: _vm._f("formatDate")(
                                _vm.details.depositExecutionDate
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _vm.details.installments.length > 0 &&
                          _vm.details.status !== "0"
                            ? _c(
                                "div",
                                { staticClass: "form-group col-sm-6" },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "createInvoiceBand" },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t(
                                              "common.pymnts_annoucement",
                                              {
                                                install_number:
                                                  _vm.details.installments
                                                    .length,
                                              }
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-striped table-bordered table-installment",
                                    },
                                    [
                                      _c(
                                        "thead",
                                        { staticClass: "thead-dark" },
                                        [
                                          _c("tr", [
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_amount"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "common.installment_date"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.details.installments,
                                          function (execution, index) {
                                            return _c(
                                              "tr",
                                              { key: "execution-" + index },
                                              [
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      execution.amount +
                                                        " " +
                                                        _vm.getCurrencyIcon(
                                                          _vm.details.currency
                                                        )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        execution.date
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.details.attachmentId
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-sm-6",
                                  class: _vm.colorBottomButton,
                                },
                                [
                                  _vm.ifAndroid
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button-action firstButtonMarginTop milkyBlockBlack",
                                          attrs: { round: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.view(
                                                _vm.details.attachmentId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon fa fa-paperclip",
                                          }),
                                          _vm._v(
                                            "\n                      View Attachment\n                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.ifAndroid
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "button-action firstButtonMarginTop milkyBlockBlack",
                                          attrs: { round: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.view(
                                                _vm.details.attachmentId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon fa fa-paperclip",
                                          }),
                                          _vm._v(
                                            "\n                        " +
                                              _vm._s(
                                                _vm.$t(
                                                  "creation_forms.dwnld_attchmnt"
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.details.direction === "0" &&
                  _vm.details.status === "0" &&
                  _vm.details.modificationInstallmentsAllowed === "1"
                    ? _c("hr")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.direction === "0" &&
                  _vm.details.status === "0" &&
                  _vm.details.modificationInstallmentsAllowed === "1"
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: "",
                            title: _vm.$t("regles_metier.titles.installments"),
                            hasDatePicker: "",
                          },
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "justify-content-start" },
                            [
                              _c("b-col", { attrs: { sm: "6" } }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "regles_metier.select_nb_installments"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6" } }, [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _vm.details.hasInstallmentRules === "1"
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.payNumber,
                                                expression: "payNumber",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.payNumber = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.$R.range(
                                              parseInt(
                                                _vm.details.installmentRules
                                                  .nbInstallments.min
                                              ),
                                              parseInt(
                                                _vm.details.installmentRules
                                                  .nbInstallments.max
                                              ) + 1
                                            ),
                                            function (nb) {
                                              return _c(
                                                "option",
                                                { domProps: { value: nb } },
                                                [
                                                  _vm._v(
                                                    "\n                          " +
                                                      _vm._s(nb) +
                                                      "\n                        "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      : _c("b-form-input", {
                                          attrs: { type: "number" },
                                          model: {
                                            value: _vm.payNumber,
                                            callback: function ($$v) {
                                              _vm.payNumber = $$v
                                            },
                                            expression: "payNumber",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("echeancier", {
                            attrs: {
                              numPay: _vm.payNumber,
                              min: _vm.borneInf,
                              amount: _vm.details.amount,
                              ccy: "€",
                              deposit: _vm.details.depositAmount,
                            },
                            model: {
                              value: _vm.multi,
                              callback: function ($$v) {
                                _vm.multi = $$v
                              },
                              expression: "multi",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.hasInstallmentRules === "1" &&
                  _vm.details.modificationInstallmentsAllowed === "1"
                    ? _c("hr")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.hasInstallmentRules === "1" &&
                  _vm.details.modificationInstallmentsAllowed === "1"
                    ? _c(
                        "form-accordion",
                        {
                          attrs: {
                            open: false,
                            title: _vm.$t("regles_metier.titles.rules_details"),
                          },
                        },
                        [
                          _c("regles-details", {
                            attrs: {
                              reglesMetier: _vm.details.installmentRules,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.details.direction === "0" && _vm.details.status === "0"
          ? _c(
              "div",
              {
                staticClass: "row justify-content-start inboxDetailButton",
                class: _vm.colorBottomButton,
              },
              [
                _c("div", { staticClass: "col-md-5 offset-md-1" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button-action firstButtonMarginTop milkyBlockBlack",
                      attrs: { round: "", disabled: !_vm.canRefuse },
                      on: {
                        click: function ($event) {
                          return _vm.refuseSDD()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon fa fa-ban" }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.refus")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-5" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button-action firstButtonMarginTop milkyBlockBlack",
                      attrs: { round: "", disabled: !_vm.canAccept },
                      on: {
                        click: function ($event) {
                          return _vm.acceptSDD()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "icon fa fa-check" }),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.accpt")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layoutBottom" }),
      _vm._v(" "),
      _c("div", { staticClass: "toolbarPageBottomBlank" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }